import React from 'react';
import UsageIcon from '../UsageIcon/UsageIcon';
import styles from './prepaidCard.module.scss';

export const VirtualCardRestrictionDiagram = () => {
  return (
    <div className={styles.virtualCardRestriction}>
      <UsageIcon location="online" usage={true} label="Online" />
      <UsageIcon location="phone" usage={true} label="Phone" />
      <UsageIcon location="in-store" usage={false} label="In-store" />
    </div>
  );
};
